import { render, staticRenderFns } from "./ComplaintEmisorDetailHeaderCard.vue?vue&type=template&id=53ce4ace"
import script from "./ComplaintEmisorDetailHeaderCard.vue?vue&type=script&lang=js"
export * from "./ComplaintEmisorDetailHeaderCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports